/**
 * Environment variables module
 * This file is safe to import from client code.
 * Only expose values here that are intentionally public in the browser.
 */

// Public environment configuration
export const ENV = {
  // API endpoints - read directly from env
  BACKEND_API: process.env.NEXT_PUBLIC_BACKEND_API || 'http://localhost:8000',
               
  // Authentication
  GOOGLE_AUTH: {
    WEB_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_WEB_CLIENT_ID || '',
    REDIRECT_URI: process.env.NEXT_PUBLIC_GOOGLE_REDIRECT_URI || 'http://localhost:3000'
  },
  MICROSOFT_AUTH: {
    CLIENT_ID: process.env.NEXT_PUBLIC_MICROSOFT_CLIENT_ID || '',
    REDIRECT_URI: process.env.NEXT_PUBLIC_MICROSOFT_REDIRECT_URI || 'http://localhost:3000'
  },

  // Cloud Storage APIs (for file picker integration)
  CLOUD_STORAGE: {
    GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '',
    GOOGLE_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_API_KEY || '',
    ONEDRIVE_CLIENT_ID: process.env.NEXT_PUBLIC_MICROSOFT_CLIENT_ID || ''
  },

  NODE_ENV: process.env.NODE_ENV || 'development',
} as const;

// Helper function to get backend URL
export function getBackendUrl(): string {
  return ENV.BACKEND_API;
}